import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const SportsListSlice = createSlice({
    name: "sportsList",
    initialState,
    reducers: {
        getSportsListRequest(state) {
            state.loading = true;
        },
        getSportsListRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getSportsListRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getSportsListRequest,
    getSportsListRequestSuccess,
    getSportsListRequestError,
} = SportsListSlice.actions;

export default SportsListSlice.reducer;
